import {
  Toolbar,
  Checkbox,
  FormControlLabel,
  Typography,
  IconButton,
  Tooltip,
  Button,
} from "@material-ui/core";
import {
  lighten,
  makeStyles
} from "@material-ui/core/styles";
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogDelete from "./dialog";
import { translate } from "react-i18next";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    flex: "0 0 auto",
  },
  containerTitle: {
    flex: "0 0 auto",
  },
  title: {
    fontSize: "1rem",
    color: "#263238",
    fontWeight: "500",
  },
  buttonActions: {
    minWidth: "max-content",
  },
}));

function EnhancedTableToolbar(props = {}) {
  const classes = useToolbarStyles();
  const {
    numSelected,
    title,
    onDelete = function () {},
    contentDialog = "",
    showActionToolbar,
    titleActionToolbar,
    actionToolbar,
    showCheckBoxToolbar,
    titleCheckBoxToolbar,
    actionCheckBoxToolbar,
    nameCheckBoxToolbar,
    valueCheckBoxToolbar,
    t,
  } = props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = () => {
    onDelete();
    handleClose();
  };

  return (
    <React.Fragment>
      <DialogDelete
        open={open}
        onClose={handleClose}
        onSubmit={onSubmit}
        content={contentDialog}
      />
      <Toolbar
        className={clsx(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        <div className={classes.containerTitle}>
          {numSelected > 0 ? (
            <Typography color="inherit" variant="subtitle1">
              {numSelected} {t("orders_tabletoolbar_selected")}
            </Typography>
          ) : (
            <Typography
              color="inherit"
              variant="subtitle1"
              className={classes.title}
            >
              {title}
            </Typography>
          )}
        </div>
        <div className={classes.spacer} />
        <div className={classes.actions}>
          {numSelected === 0 && showCheckBoxToolbar && (
            <Tooltip title="Checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!valueCheckBoxToolbar}
                    name={nameCheckBoxToolbar}
                    onChange={actionCheckBoxToolbar}
                  />
                }
                // className={classes.label}
                label={titleCheckBoxToolbar}
              />
            </Tooltip>
          )}
          {numSelected === 0 && showActionToolbar && (
            <Tooltip title="Action">
              <Button
                size="medium"
                onClick={actionToolbar}
                variant="outlined"
                color="primary"
              >
                {titleActionToolbar}
              </Button>
            </Tooltip>
          )}
          {numSelected > 0 ? (
            <Tooltip title={t("toolbar_delete")} onClick={handleClickOpen}>
              <IconButton aria-label="delete">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )}
        </div>
      </Toolbar>
    </React.Fragment>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};
EnhancedTableToolbar.defaultProps = {
  showActionToolbar: false,
  titleActionToolbar: "",
  actionToolbar: null,
  showCheckBoxToolbar: false,
  titleCheckBoxToolbar: "",
  actionCheckBoxToolbar: null,
  nameCheckBoxToolbar: "",
  valueCheckBoxToolbar: 0,
};
export default translate("translations")(EnhancedTableToolbar);
